
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from "@/components/ui/button";
import { Plus, Webhook } from "lucide-react";

interface SectionsActionButtonsProps {
  onAddSection: () => void;
  onWebhooksClick: () => void;
}

export const SectionsActionButtons = ({
  onAddSection,
  onWebhooksClick
}: SectionsActionButtonsProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between items-start">
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
        <Button variant="outline" className="flex items-center gap-2 w-full sm:w-auto py-3 sm:py-2" onClick={onAddSection}>
          <Plus className="h-4 w-4" />
          {t('add_custom_section')}
        </Button>
        <Button variant="outline" className="flex items-center gap-2 w-full sm:w-auto py-3 sm:py-2" onClick={onWebhooksClick}>
          <Webhook className="h-4 w-4" />
          {t('webhooks')}
        </Button>
      </div>
    </div>
  );
};
